import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import { lg, md, xl } from '../common';

export function initReviewsSlider() {
  const parent = document.querySelector('.js-reviews-slider');
  if (!parent) return;

  const swiper = parent.querySelector('.swiper');
  const prevEl = parent.querySelector('.swiper-button-prev');
  const nextEl = parent.querySelector('.swiper-button-next');

  new Swiper(swiper, {
    modules: [Pagination, Navigation],
    slidesPerView: 'auto',
    spaceBetween: 16,
    loop: true,
    navigation: {
      nextEl,
      prevEl,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      [lg]: {
        spaceBetween: 20,
      },
    },
  });
}
